import { removeAuthCookie } from './cookie';

export const onLogout = (onLogout?: () => void) => {
    removeAuthCookie();
    onLogout?.();
};
